import Flag from '../assets/flag.svg?react'

interface IReplyCardProps {
  username: string
  replyText: string
  date: string
  isOwnReply: boolean
  isHighlighted?: boolean
  onReport?: () => void
}

export const ReplyCard = (props: IReplyCardProps) => {
  return (
    <div className={`p-6 mb-4 rounded-lg ${props.isHighlighted ? 'bg-red-50 border-2 border-red-400' : 'bg-gray-50'}`}>
      {/* Header with username and date */}
      <div className={'flex items-start justify-between mb-3'}>
        <h4 className={'text-lg font-semibold'}>{props.username}</h4>
        <span className={'text-sm text-gray-500'}>{props.date}</span>
      </div>

      {/* Reply text */}
      <p className={`text-base text-gray-700 ${props.isOwnReply ? '' : 'mb-4'}`}>{props.replyText}</p>

      {/* Action buttons */}
      {!props.isOwnReply && (
        <div className={'flex justify-end'}>
          <button
            onClick={props.onReport}
            className={
              'flex items-center gap-2 text-sm text-gray-600 hover:text-red-600 cursor-pointer transition-colors'
            }
          >
            <Flag width={14} height={14} />
            <span>Report</span>
          </button>
        </div>
      )}
    </div>
  )
}
